/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { AtomoNumbToken } from "../AtomoNumbToken";
import "./style.css";

export const MoleculaTokenNumbs = ({
  default1,
  active,
  error,
  className,
  atomoNumbTokenElementClassName,
  atomoNumbTokenAtomoNumbTokenClassName,
  atomoNumbTokenElementClassNameOverride,
  atomoNumbTokenAtomoNumbTokenClassNameOverride,
  atomoNumbTokenDivClassName,
  atomoNumbTokenText,
  atomoNumbTokenElementWrapperClassName,
  atomoNumbTokenDivClassNameOverride,
  atomoNumbTokenText1,
  atomoNumbTokenElementWrapperClassNameOverride,
  atomoNumbTokenElementClassName1,
  atomoNumbTokenText2,
  atomoNumbTokenAtomoNumbTokenClassName1,
  atomoNumbTokenElementClassName2,
  atomoNumbTokenText3,
  atomoNumbTokenAtomoNumbTokenClassName2,
}) => {
  return (
    <div className={`molecula-token-numbs ${className}`}>
      <div className="content">
        <div className="numbs">
          <AtomoNumbToken
            className={atomoNumbTokenAtomoNumbTokenClassName}
            elementClassName={atomoNumbTokenElementClassName}
            hasElement={!active ? false : undefined}
            text={active ? "0" : undefined}
          />
          <AtomoNumbToken
            className={atomoNumbTokenAtomoNumbTokenClassNameOverride}
            elementClassName={atomoNumbTokenElementClassNameOverride}
            hasElement={!active ? false : undefined}
            text={active ? "0" : undefined}
          />
          <AtomoNumbToken
            className={atomoNumbTokenElementWrapperClassName}
            elementClassName={atomoNumbTokenDivClassName}
            hasElement={!active ? false : undefined}
            text={atomoNumbTokenText}
          />
          <AtomoNumbToken
            className={atomoNumbTokenElementWrapperClassNameOverride}
            elementClassName={atomoNumbTokenDivClassNameOverride}
            hasElement={!active ? false : undefined}
            text={atomoNumbTokenText1}
          />
          <AtomoNumbToken
            className={atomoNumbTokenAtomoNumbTokenClassName1}
            elementClassName={atomoNumbTokenElementClassName1}
            hasElement={!active ? false : undefined}
            text={atomoNumbTokenText2}
          />
          <AtomoNumbToken
            className={atomoNumbTokenAtomoNumbTokenClassName2}
            elementClassName={atomoNumbTokenElementClassName2}
            hasElement={!active ? false : undefined}
            text={atomoNumbTokenText3}
          />
        </div>

        {error && <p className="text-wrapper">Mensaje de error del campo</p>}
      </div>
    </div>
  );
};

MoleculaTokenNumbs.propTypes = {
  default1: PropTypes.bool,
  active: PropTypes.bool,
  error: PropTypes.bool,
  atomoNumbTokenText: PropTypes.string,
  atomoNumbTokenText1: PropTypes.string,
  atomoNumbTokenText2: PropTypes.string,
  atomoNumbTokenText3: PropTypes.string,
};
